import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { getAllCategorys } from "../../../redux/actions/categories";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createHashHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class MerchantPayon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'PAY_ON_REDEMPTION',
      path: ["Home", "Merchant Pay On Redemption Report"],
      links: ["home", "report/merchant-payon"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
      catData: '',
      catID: '',
      merchantTypeID: '',
      totalRecords: 0,
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          catID:  this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          offer_ids: this.state.offerIDs,
          site_id: localStorage.getItem("siteID")
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          catID:  this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          offer_ids: this.state.offerIDs,
          site_id: localStorage.getItem("siteID")
        };
      }

      this.props.getReport(formData, 'report/merchant-payon');
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getAllCategorys({site_id: localStorage.getItem("siteID")});
    this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'), site_id: localStorage.getItem("siteID")}, 'report/merchant-payon');
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ totalRecords: nextProps.reportData.total_record });
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        isLoading = "false";
        this.setState({ catData: nextProps.catData.data.data });
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Data up to the date: ' + setDate,
      ],
      [
        'Total Records : ' + this.state.totalRecords,
      ],
      [
        'All Markets',
        'Offer ID',
        'Offer Name',
        'Start Date',
        'End Date',
        'Company ID', 
        'Legal Name',
        'Payment Terms Name', 
        'Gross Sales',
        'Adjusted Gross Sales', 
        'Quanity Purchased ', 
        'Quantity Redeemed ', 
        'Number Expired ',
        'Redeemed After Expiration ',
        'Net Payout Expired ',
        'Due Date',
        'Net Payout',
        'Amount Remaining',
        'Credit Card Fee',
        'Due Now',
        'Amount Paid',
        'SSN/TIN',
        '0', 
      ]
    ];

    {data &&
      data.data.map((data, index) =>
        Object.keys(data).map((key, indexkey) =>
          (key == 'city') ?
            csvData.push([data.city])
          :
            data.payouts.map((payData, payIndex) =>
            csvData.push([
              payData.merchantName,
              payData.offerID,
              payData.offerName,
              payData.startDate,
              payData.endDate,
              payData.siteID, 
              payData.legalName,
              payData.termName, 
              payData.grossSale,
              payData.adjustedGrossSale, 
              payData.quantityPurchased , 
              payData.vouchersRedeemed , 
              payData.vouchersExpired ,
              payData.redeemedAfterExpiration ,
              payData.netPayoutExpired ,
              payData.due_date,
              payData.netPayout,
              payData.amountRemaining,
              payData.credit_card_fee,
              payData.due_now,
              payData.paidAmount,
              payData.tin_ssn,
              payData.total_vouchers ,
            ])
          )
        )
      )
    }

    this.setState({ csvData: csvData });
  };

  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Merchant Pay On Redemption Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col> 
                <Col md={3} xs={12}>
                  <FormGroup>
                    <ControlLabel>Offer IDs (separate by comma)</ControlLabel>
                    <FormControl
                        type="text"
                        name="offerIDs"
                        value={this.state.offerIDs}
                        onChange={this.handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      name="catID"
                      onChange={this.handleChange}
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>  
                <Col md={3} xs={12}>
                    <FormGroup controlId="formParentID">
                      <ControlLabel>Proposal Type</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="merchantTypeID"
                        onChange={this.handleChange}
                        placeholder="select"
                        value={this.state.merchantTypeID}
                      >
                        <option value="">All</option>
                        <option value="1">Standard Merchant</option>
                        <option value="2">Premium Merchant</option>
                        <option value="3">Products</option>
                        <option value="4">Travel</option>
                        <option value="5">Events</option>
                        <option value="6">Coupon Offer</option>
                        <option value="7">Affiliate Offer</option>
                      </FormControl>
                    </FormGroup>
                  </Col>          
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"merchantpayoutpaid-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="24">Data up to the date: {(this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY')}</th>
                </tr>
                <tr>
                  <th colSpan="24">Total Records : {this.state.totalRecords}</th>
                </tr>
                <tr>
                  <th>All Markets</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Company ID</th> 
                  <th>Legal Name</th>
                  <th>Payment Terms Name</th> 
                  <th>Gross Sales</th>
                  <th>Adjusted Gross Sales</th> 
                  <th>Quanity Purchased </th> 
                  <th>Quantity Redeemed </th> 
                  <th>Number Expired </th>
                  <th>Redeemed After Expiration </th>
                  <th>Net Payout Expired </th>
                  <th>Due Date</th>
                  <th>Net Payout</th>
                  <th>Amount Remaining</th>
                  <th>Credit Card Fee</th>
                  <th>Due Now</th>
                  <th>Amount Paid</th>
                  <th>SSN/TIN</th>
                  <th>0</th> 
                </tr>
              </thead>
              <tbody>
              {this.state.reportData ?
                this.state.reportData.data.map((data, index) =>
                  Object.keys(data).map((key, indexkey) =>
                    (key == 'city') ? 
                    <tr key={data.city + index}>
                      <td colSpan="24">{data.city}</td>
                    </tr>
                    :
                    data.payouts.map((payData, payIndex) => 
                    <tr key={payData.offerID + payIndex}>
                      <td>{payData.merchantName}</td>
                      <td>{payData.offerID}</td>
                      <td>{payData.offerName}</td>
                      <td>{payData.startDate}</td>
                      <td>{payData.endDate}</td>
                      <td>{payData.siteID}</td> 
                      <td>{payData.legalName}</td>
                      <td>{payData.termName}</td> 
                      <td>{payData.grossSale}</td>
                      <td>{payData.adjustedGrossSale}</td> 
                      <td>{payData.quantityPurchased }</td> 
                      <td>{payData.vouchersRedeemed }</td> 
                      <td>{payData.vouchersExpired }</td>
                      <td>{payData.redeemedAfterExpiration }</td>
                      <td>{payData.netPayoutExpired }</td>
                      <td>{payData.due_date}</td>
                      <td>{payData.netPayout}</td>
                      <td>{payData.amountRemaining}</td>
                      <td>{payData.credit_card_fee}</td>
                      <td>{payData.due_now}</td>
                      <td>{payData.paidAmount}</td>
                      <td>{payData.tin_ssn}</td>
                      <td>{payData.total_vouchers}</td>
                    </tr>
                    )
                  )
                )
                :
                <tr><td colSpan="24">Data Not Found</td></tr>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
    catData: state.categoryReducer.catData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
    getAllCategorys,
  })
)(MerchantPayon);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/MerchantPayon.js